// extracted by mini-css-extract-plugin
export default {"navContainer":"StepsNav_navContainer__ZWbOG","active":"StepsNav_active__+rHXD"};